import { defineStore } from "pinia";
import { ref } from "vue";

export type BookingToastType = "success" | "error" | "info" | "warning";

export interface BookingToastMessage {
  id: number;
  type: BookingToastType;
  title: string;
  text?: string;
}

const DEFAULT_DURATION_MS = 3200;

export const useBookingToastStore = defineStore("bookingToast", () => {
  const toasts = ref<BookingToastMessage[]>([]);
  let nextToastId = 0;

  function push(type: BookingToastType, title: string, text?: string, durationMs = DEFAULT_DURATION_MS) {
    if (!title) return;

    const id = ++nextToastId;
    toasts.value.push({ id, type, title, text });

    globalThis.setTimeout(() => {
      dismiss(id);
    }, durationMs);
  }

  function dismiss(id: number) {
    toasts.value = toasts.value.filter((toast) => toast.id !== id);
  }

  return {
    toasts,
    push,
    dismiss,
  };
});
